<template>
  <div id="home">
    <div class="panel">
      <div class="draw-container" v-show="showMenu">
        <swiper :slidesPerView="1" :spaceBetween="0" :centeredSlides="true" :loop="true" :navigation="true"
          @slideChange="onSlideChange">
          <swiper-slide v-for="(img, index) in imgsSrc" :key="index">
            <div class="card" @click="onImgClick(index)">
              <img :src="img" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="button-container">
        <div class="button-icon">
          <i class="icon el-icon-location-outline" @click="onHomeClick"></i>
          <p class="label">起点</p>
        </div>
        <div class="button-icon">
          <i class="icon el-icon-menu" @click="onMenuClick"></i>
          <p class="label">列表</p>
        </div>
        <div class="button-icon">
          <i class="icon el-icon-video-play" v-show="!autoPlaying" @click="onPlayClick"></i>
          <i class="icon el-icon-video-pause" v-show="autoPlaying" @click="onStopClick"></i>
          <p class="label" v-show="!autoPlaying">播放</p>
          <p class="label" v-show="autoPlaying">停止</p>
        </div>
      </div>
    </div>
    <!-- <el-image
      style="display: none;" ref="previewImg" :src="previewImg"
      :preview-src-list="imgsSrc">
      </el-image> -->
    <el-image-viewer v-if="showImageViewer" :initialIndex="currentPreviewImg" :on-close="closeImgViewer"
      :url-list="imgsSrc" :drawName="drawName" />
    <div class="loader-wrapper" v-show="showLoading">
      <div class="loader-section">
        <el-progress class="progress" :text-inside="true" color="#7f9df0" :stroke-width="30"
          :percentage="loadingPercentage"></el-progress>
        <div class="load_title">正在加载,请耐心等待</div>
      </div>
    </div>

    <!-- 音乐按钮 -->
    <div class="music" @click="onClickMusic"><img src="assets/music.png" alt="" :style="musicStyle" /></div>
    <audio id="music" loop="">
      <source src="assets/music.mp3" />
    </audio>
  </div>
</template>

<script>

import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: 'HomeView',
  components: {
    swiper, swiperSlide,
    'el-image-viewer': () => import('../components/image-viewer')
  },
  data() {
    return {
      gallery: null,
      showMenu: true,
      autoPlaying: false,
      imgs: [
      ],
      imgsSrc: [],
      initCenter: '0 0 0',
      directions: {1: 0, 12: 0, 13: 0, 14: 0, 30: 0, 31: 0, 32: 0, 37: 0, 38: 0, 0: 1, 10: 1, 11: 1, 15: 1, 2: 1, 21: 1, 22: 1, 23: 1, 27: 1, 28: 1, 29: 1, 3: 1, 34: 1, 36: 1, 9: 1, 16: 2, 17: 2, 18: 2, 19: 2, 20: 2, 24: 2, 25: 2, 26: 2, 33: 2, 35: 2, 4: 2, 5: 2, 6: 2, 7: 2, 8: 2},
      directionAngles: [-90, 0, 180, 90],    // 前：-90 后：90 左：0 右：180 
      currentPlayIndex: 0,
      showImageViewer: false,
      currentPreviewImg: 0,
      drawName: "",

      showLoading: true,
      loadingPercentage: 0,
      loadingInterval: null,
      musicStyle: {
        animationPlayState: "paused"
      },
    };
  },
  created() {
    window.app = this;
    // 加载
    this.loadingInterval = setInterval(() => {
      this.loadingPercentage += 1;
      if (this.loadingPercentage > 90) {
        this.loadingPercentage = 90;
      }
    }, 100);

    this.gallery = window.gallery;
    setTimeout(() => {
      // this.initCenter = `${0.2 * this.gallery.autoScale} ${0.06 * this.gallery.autoScale} ${0 * this.gallery.autoScale}`;
      this.initCenter = `0 0 0`;
    }, 1000);
    for (let i = 1; i <= 39; ++i) {
      this.imgs.push(`pic ${i}.jpg`);
    }
    this.imgs.forEach((item) => {
      // this.imgsSrc.push(require(`@/assets/imgs/${item}`));
      this.imgsSrc.push(`./assets/model/${item}`);
    });
    this.gallery.directions = this.directions;
    this.gallery.directionAngles = this.directionAngles;

  },
  methods: {
    onLoadingDone() {
      clearInterval(this.loadingInterval);
      this.loadingInterval = null;
      this.loadingPercentage = 100;
      setTimeout(() => {
        this.showLoading = false;
      }, 1000);
    },
    onHomeClick() {
      if (this.autoPlaying) {
        this.$message({
          message: "自动播放中，请先停止！",
          type: "warning"
        });
        return;
      }
      this.gallery.moving = true;
      this.gallery.grabbable = false;
      this.gallery.moveTo(
        {
          direction: -90,
          elevation: 0,
          // center: `${0.2 * this.gallery.autoScale} ${0.06 * this.gallery.autoScale} ${0 * this.gallery.autoScale}`,
          center: `0 0 0`,
        },
        {
          speed: 0.3,
          easing: "ease-out",
          onfinish: () => {
            this.gallery.grabbable = true;
          },
        }
      );
    },
    onMenuClick() {
      this.showMenu = !this.showMenu;
    },
    onPlayClick() {
      this.$message({
        message: "自动播放已开始！",
        type: "success"
      });
      this.showMenu = false;
      this.autoPlaying = true;
      this.gallery.autoPlaying = true;
      this.moveToPosition(this.currentPlayIndex, true);
    },
    onStopClick() {
      this.$message({
        message: "自动播放已停止！",
        type: "success"
      });
      this.autoPlaying = false;
      this.gallery.autoPlaying = false;
      this.gallery.moveTo({});
      this.gallery.grabbable = true;
    },
    onSlideChange() {
      console.log('slide change');
    },
    onImgClick(index) {
      if (this.autoPlaying) {
        this.$message({
          message: "自动播放中，请先停止！",
          type: "warning"
        });
        return;
      }
      this.moveToPosition(index);
    },
    onImgOpen(index) {
      this.showImageViewer = true;
      this.currentPreviewImg = index;
      if(`${index}` in this.gallery.drawNames){
        this.drawName = this.gallery.drawNames[`${index}`];
      }
    },
    closeImgViewer() {
      this.showImageViewer = false;
    },
    jumpWebsite() {
      alert("跳转");
    },
    moveToPosition(index, isAuto = false) {
      let targetPosition = this.gallery.getPosition(`position_${index}`);
      let directionIndex = 0;
      if (index in this.directions)
        directionIndex = this.directions[index];
      this.gallery.grabbable = false;
      this.gallery.moveTo(
        {
          center: targetPosition,
          elevation: 0,
          direction: this.directionAngles[directionIndex],
        },
        {
          speed: 0.3,
          onfinish: () => {
            this.gallery.moving = false;
            if (isAuto && this.autoPlaying) {
              setTimeout(() => {
                if (!this.autoPlaying) return;
                this.currentPlayIndex++;
                this.currentPlayIndex = this.currentPlayIndex % this.imgsSrc.length;
                this.moveToPosition(this.currentPlayIndex, true);
              }, 1000);
            }
            else
              this.gallery.grabbable = true;
          }
        }
      );

    },
    onClickMusic() {
      let music = document.querySelector("#music");
      if (music.paused) {
        music.play();
        console.log("PlayMusic");
        this.musicStyle.animationPlayState = "running";
      } else {
        music.pause();
        console.log("PauseMusic");
        this.musicStyle.animationPlayState = "paused";
      }
    },
  }
}
</script>

<style>
#home {
  width: 100vw;
  height: auto;
  position: absolute;
  bottom: 0;
  z-index: 999;
  overflow: hidden
}

.panel {
  width: 100vw;
  display: flex;
  flex-direction: column;
}

.draw-container {
  margin: auto;
  width: 35vw;
  height: auto;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  margin-bottom: 5px;
}

@media screen and (min-width: 1000px) {
  .draw-container {
    width: 35vw;
  }
}

@media screen and (min-width: 600px) and (max-width: 1001px) {
  .draw-container {
    width: 50vw;
  }
}

@media screen and (max-width: 601px) {
  .draw-container {
    width: 80vw;
  }
}

.swiper {
  width: 100%;
  height: 100%;
  width: 100%;
  height: 300px;
  margin: 20px auto;
}

.swiper-slide {
  text-align: center;

  /* Center slide text vertically */
  width: 70px !important;
  /* margin: 0 10px; */
}

.swiper-slide .card {
  width: 60px;
  height: 60px;
  background-color: white;
}

.swiper-slide .card img {
  width: auto;
  height: 100%;
  object-fit: cover;
}

.swiper-slide .card:hover {
  cursor: pointer;
}


.button-container {
  margin: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: auto;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
}

.button-icon {
  width: 50px;
  color: white;
  text-align: center;
  margin: 0 4vw;
}

@media screen and (min-width: 1000px) {
  .button-icon {
    width: 50px;
    margin: 0 4vw;
  }
}

@media screen and (min-width: 600px) and (max-width: 1001px) {
  .button-icon {
    width: 50px;
    font-size: medium;
    margin: 0 3vw;
  }
}

@media screen and (max-width: 601px) {
  .button-icon {
    font-size: small;
    width: 30px;
    margin: 0 2vw;
  }
}


.button-icon .icon {
  scale: 1.8;
}

.button-icon .icon:hover {
  cursor: pointer;
}

.button-icon .label {
  margin: 0;
  margin-top: 10px;
}

/* 加载页面 */
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background: #7171C6;
}

.loader-section {
  margin: auto;
  position: absolute;
  top: 50%;
  width: 100%;
}

.loader-section .progress {
  width: 50%;
  margin: auto;
}

.loader-section .load_title {
  font-family: 'Open Sans';
  color: #FFF;
  font-size: 19px;
  width: 100%;
  text-align: center;
  z-index: 9999999999999;
  opacity: 1;
  line-height: 30px;
}

.loader-section .load_title span {
  font-weight: normal;
  font-style: italic;
  font-size: 13px;
  color: #FFF;
  opacity: 0.5;
}

@media screen and (min-width: 1000px) {
  .loader-section .progress {
    width: 50%;
  }
}

@media screen and (min-width: 600px) and (max-width: 1001px) {
  .loader-section .progress {
    width: 60%;
  }
}

@media screen and (max-width: 601px) {
  .loader-section .progress {
    width: 80%;
  }
}


.music {
  width: 32px;
  height: 32px;
  position: fixed;
  left: 0;
  top: 0;
  padding-left: 20px;
  padding-top: 20px;
  cursor: pointer;
}

.music img {
  width: 100%;
  height: auto;
  pointer-events: none;
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;
  -webkit-animation-play-state: paused;
  animation-play-state: paused;
}

#music {
  display: none;
}

@-webkit-keyframes rotate {
  0% {
    transform: rotate(0deg)
  }

  100% {
    transform: rotate(360deg)
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg)
  }

  100% {
    transform: rotate(360deg)
  }
}
</style>
